import { ActionTiles } from '@ps/isp-web-component-library';
import { BetBuilderBadgeAll } from '@ps/isp-web-component-library/icons/BetBuilderBadgeAll';
import { BetBuilderBadgeAllActive } from '@ps/isp-web-component-library/icons/BetBuilderBadgeAllActive';
import { BetBuilderBadgeAmericanPassing } from '@ps/isp-web-component-library/icons/BetBuilderBadgeAmericanPassing';
import { BetBuilderBadgeAmericanPassingActive } from '@ps/isp-web-component-library/icons/BetBuilderBadgeAmericanPassingActive';
import { BetBuilderBadgeAmericanReceiving } from '@ps/isp-web-component-library/icons/BetBuilderBadgeAmericanReceiving';
import { BetBuilderBadgeAmericanReceivingActive } from '@ps/isp-web-component-library/icons/BetBuilderBadgeAmericanReceivingActive';
import { BetBuilderBadgeAmericanResult } from '@ps/isp-web-component-library/icons/BetBuilderBadgeAmericanResult';
import { BetBuilderBadgeAmericanResultActive } from '@ps/isp-web-component-library/icons/BetBuilderBadgeAmericanResultActive';
import { BetBuilderBadgeAmericanRushing } from '@ps/isp-web-component-library/icons/BetBuilderBadgeAmericanRushing';
import { BetBuilderBadgeAmericanRushingActive } from '@ps/isp-web-component-library/icons/BetBuilderBadgeAmericanRushingActive';
import { BetBuilderBadgeAmericanTd } from '@ps/isp-web-component-library/icons/BetBuilderBadgeAmericanTd';
import { BetBuilderBadgeAmericanTdActive } from '@ps/isp-web-component-library/icons/BetBuilderBadgeAmericanTdActive';
import { BetBuilderBadgeBasketballAssist } from '@ps/isp-web-component-library/icons/BetBuilderBadgeBasketballAssist';
import { BetBuilderBadgeBasketballAssistActive } from '@ps/isp-web-component-library/icons/BetBuilderBadgeBasketballAssistActive';
import { BetBuilderBadgeBasketballPlayerPoints } from '@ps/isp-web-component-library/icons/BetBuilderBadgeBasketballPlayerPoints';
import { BetBuilderBadgeBasketballPlayerPointsActive } from '@ps/isp-web-component-library/icons/BetBuilderBadgeBasketballPlayerPointsActive';
import { BetBuilderBadgeBasketballRebounds } from '@ps/isp-web-component-library/icons/BetBuilderBadgeBasketballRebounds';
import { BetBuilderBadgeBasketballReboundsActive } from '@ps/isp-web-component-library/icons/BetBuilderBadgeBasketballReboundsActive';
import { BetBuilderBadgeBasketballResult } from '@ps/isp-web-component-library/icons/BetBuilderBadgeBasketballResult';
import { BetBuilderBadgeBasketballResultActive } from '@ps/isp-web-component-library/icons/BetBuilderBadgeBasketballResultActive';
import { BetBuilderBadgeBasketballThrees } from '@ps/isp-web-component-library/icons/BetBuilderBadgeBasketballThrees';
import { BetBuilderBadgeBasketballThreesActive } from '@ps/isp-web-component-library/icons/BetBuilderBadgeBasketballThreesActive';
import { BetBuilderBadgeCorners } from '@ps/isp-web-component-library/icons/BetBuilderBadgeCorners';
import { BetBuilderBadgeCornersActive } from '@ps/isp-web-component-library/icons/BetBuilderBadgeCornersActive';
import { BetBuilderBadgeGoals } from '@ps/isp-web-component-library/icons/BetBuilderBadgeGoals';
import { BetBuilderBadgeGoalsActive } from '@ps/isp-web-component-library/icons/BetBuilderBadgeGoalsActive';
import { BetBuilderBadgePlayers } from '@ps/isp-web-component-library/icons/BetBuilderBadgePlayers';
import { BetBuilderBadgePlayersActive } from '@ps/isp-web-component-library/icons/BetBuilderBadgePlayersActive';
import { BetBuilderBadgeResult } from '@ps/isp-web-component-library/icons/BetBuilderBadgeResult';
import { BetBuilderBadgeResultActive } from '@ps/isp-web-component-library/icons/BetBuilderBadgeResultActive';
import { BetBuilderBadgeYellowCards } from '@ps/isp-web-component-library/icons/BetBuilderBadgeYellowCards';
import { BetBuilderBadgeYellowCardsActive } from '@ps/isp-web-component-library/icons/BetBuilderBadgeYellowCardsActive';
import { SubMarketGroupType } from '@ps/isp-web-services-types';
import { useTrackers } from '@ps/web-shared-analytics';
import { Translation, useTrackingLabel } from '@ps/web-shared-components';
import { EventTypeId } from '@ps/web-sports-enums';
import type { PropsWithoutRef, SVGProps } from 'react';
import { useSelector } from 'react-redux';

import { useSportsEventPageWidget } from '../../../../model';
import type { ClientMarketGroup } from '../../../../model/types';

import {
  TXTWCL_All_53,
  TXTWCL_Cards,
  TXTWCL_Corners_2,
  TXTWCL_Goals_1,
  TXTWCL_Passing,
  TXTWCL_Player_48,
  TXTWCL_Player_Assists,
  TXTWCL_Player_Points,
  TXTWCL_Player_Rebounds,
  TXTWCL_Player_Threes,
  TXTWCL_Receiving_1,
  TXTWCL_Result_5,
  TXTWCL_Rushing,
  TXTWCL_TDs
} from './MarketGroupActionTiles.messages.json';

interface SubMarketGroupIcons {
  default: React.ElementType<PropsWithoutRef<SVGProps<SVGSVGElement>>>;
  active: React.ElementType<PropsWithoutRef<SVGProps<SVGSVGElement>>>;
  translation: {
    id: string;
    defaultMessage: string;
  };
  key: SubMarketGroupType;
}

const getSubMarketGroupIcons = (
  eventTypeId?: EventTypeId
): Record<SubMarketGroupType, SubMarketGroupIcons> => {
  let resultIcon = BetBuilderBadgeResult;
  let resultIconActive = BetBuilderBadgeResultActive;

  switch (eventTypeId) {
    case EventTypeId.AMERICAN_FOOTBALL:
      resultIcon = BetBuilderBadgeAmericanResult;
      resultIconActive = BetBuilderBadgeAmericanResultActive;
      break;
    case EventTypeId.BASKETBALL:
      resultIcon = BetBuilderBadgeBasketballResult;
      resultIconActive = BetBuilderBadgeBasketballResultActive;
      break;
  }

  return {
    [SubMarketGroupType.ALL]: {
      default: BetBuilderBadgeAll,
      active: BetBuilderBadgeAllActive,
      translation: TXTWCL_All_53,
      key: SubMarketGroupType.ALL
    },
    [SubMarketGroupType.TOUCHDOWNS]: {
      default: BetBuilderBadgeAmericanTd,
      active: BetBuilderBadgeAmericanTdActive,
      translation: TXTWCL_TDs,
      key: SubMarketGroupType.TOUCHDOWNS
    },
    [SubMarketGroupType.PLAYER]: {
      default: BetBuilderBadgePlayers,
      active: BetBuilderBadgePlayersActive,
      translation: TXTWCL_Player_48,
      key: SubMarketGroupType.PLAYER
    },
    [SubMarketGroupType.RESULT]: {
      default: resultIcon,
      active: resultIconActive,
      translation: TXTWCL_Result_5,
      key: SubMarketGroupType.RESULT
    },
    [SubMarketGroupType.GOALS]: {
      default: BetBuilderBadgeGoals,
      active: BetBuilderBadgeGoalsActive,
      translation: TXTWCL_Goals_1,
      key: SubMarketGroupType.GOALS
    },
    [SubMarketGroupType.CORNERS]: {
      default: BetBuilderBadgeCorners,
      active: BetBuilderBadgeCornersActive,
      translation: TXTWCL_Corners_2,
      key: SubMarketGroupType.CORNERS
    },
    [SubMarketGroupType.CARDS]: {
      default: BetBuilderBadgeYellowCards,
      active: BetBuilderBadgeYellowCardsActive,
      translation: TXTWCL_Cards,
      key: SubMarketGroupType.CARDS
    },
    [SubMarketGroupType.PASSING]: {
      default: BetBuilderBadgeAmericanPassing,
      active: BetBuilderBadgeAmericanPassingActive,
      translation: TXTWCL_Passing,
      key: SubMarketGroupType.PASSING
    },
    [SubMarketGroupType.RECEIVING]: {
      default: BetBuilderBadgeAmericanReceiving,
      active: BetBuilderBadgeAmericanReceivingActive,
      translation: TXTWCL_Receiving_1,
      key: SubMarketGroupType.RECEIVING
    },
    [SubMarketGroupType.RUSHING]: {
      default: BetBuilderBadgeAmericanRushing,
      active: BetBuilderBadgeAmericanRushingActive,
      translation: TXTWCL_Rushing,
      key: SubMarketGroupType.RUSHING
    },
    [SubMarketGroupType.PLAYER_POINTS]: {
      default: BetBuilderBadgeBasketballPlayerPoints,
      active: BetBuilderBadgeBasketballPlayerPointsActive,
      translation: TXTWCL_Player_Points,
      key: SubMarketGroupType.PLAYER_POINTS
    },
    [SubMarketGroupType.PLAYER_REBOUNDS]: {
      default: BetBuilderBadgeBasketballRebounds,
      active: BetBuilderBadgeBasketballReboundsActive,
      translation: TXTWCL_Player_Rebounds,
      key: SubMarketGroupType.PLAYER_REBOUNDS
    },
    [SubMarketGroupType.PLAYER_ASSISTS]: {
      default: BetBuilderBadgeBasketballAssist,
      active: BetBuilderBadgeBasketballAssistActive,
      translation: TXTWCL_Player_Assists,
      key: SubMarketGroupType.PLAYER_ASSISTS
    },
    [SubMarketGroupType.PLAYER_THREES]: {
      default: BetBuilderBadgeBasketballThrees,
      active: BetBuilderBadgeBasketballThreesActive,
      translation: TXTWCL_Player_Threes,
      key: SubMarketGroupType.PLAYER_THREES
    }
  };
};

interface Props {
  eventTypeId: EventTypeId;
  marketGroup: ClientMarketGroup;
  onTileSelected: (type: SubMarketGroupType | undefined) => void;
}

export const MarketGroupActionTiles: React.FC<Props> = ({
  eventTypeId,
  marketGroup,
  onTileSelected
}) => {
  const { widgetSelect } = useSportsEventPageWidget();
  const { tabClicked } = useTrackers();
  const allLabel = useTrackingLabel(TXTWCL_All_53);
  const playerLabel = useTrackingLabel(TXTWCL_Player_48);
  const resultLabel = useTrackingLabel(TXTWCL_Result_5);
  const goalsLabel = useTrackingLabel(TXTWCL_Goals_1);
  const cornersLabel = useTrackingLabel(TXTWCL_Corners_2);
  const cardsLabel = useTrackingLabel(TXTWCL_Cards);
  const touchdownsLabel = useTrackingLabel(TXTWCL_TDs);
  const passingLabel = useTrackingLabel(TXTWCL_Passing);
  const rushingLabel = useTrackingLabel(TXTWCL_Rushing);
  const receivingLabel = useTrackingLabel(TXTWCL_Receiving_1);
  const playerPointsLabel = useTrackingLabel(TXTWCL_Player_Points);
  const playerReboundsLabel = useTrackingLabel(TXTWCL_Player_Rebounds);
  const playerAssistsLabel = useTrackingLabel(TXTWCL_Player_Assists);
  const playerThreesLabel = useTrackingLabel(TXTWCL_Player_Threes);

  const tabLabels: Record<SubMarketGroupType, string> = {
    [SubMarketGroupType.ALL]: allLabel || 'All',
    [SubMarketGroupType.PLAYER]: playerLabel || 'Player',
    [SubMarketGroupType.RESULT]: resultLabel || 'Result',
    [SubMarketGroupType.GOALS]: goalsLabel || 'Goals',
    [SubMarketGroupType.CORNERS]: cornersLabel || 'Corners',
    [SubMarketGroupType.CARDS]: cardsLabel || 'Cards',
    [SubMarketGroupType.TOUCHDOWNS]: touchdownsLabel || 'Touchdowns',
    [SubMarketGroupType.PASSING]: passingLabel || 'Passing',
    [SubMarketGroupType.RUSHING]: rushingLabel || 'Rushing',
    [SubMarketGroupType.RECEIVING]: receivingLabel || 'Receiving',
    [SubMarketGroupType.PLAYER_POINTS]: playerPointsLabel || 'Player Points',
    [SubMarketGroupType.PLAYER_REBOUNDS]: playerReboundsLabel || 'Player Rebounds',
    [SubMarketGroupType.PLAYER_ASSISTS]: playerAssistsLabel || 'Player Assists',
    [SubMarketGroupType.PLAYER_THREES]: playerThreesLabel || 'Player Threes'
  };

  const handleTileClick = (key?: SubMarketGroupType) => {
    const tabLabel = key ? tabLabels[key] : 'All';
    tabClicked({ tabName: tabLabel });
    onTileSelected(key);
  };
  const selectedSubMarketGroupType = useSelector(widgetSelect.selectedSubMarketGroupType);

  const { groupedTemplates } = marketGroup;

  if (!groupedTemplates || !groupedTemplates.length || groupedTemplates.length < 2) return null;

  const allMarkets = getSubMarketGroupIcons(eventTypeId)[SubMarketGroupType.ALL];

  return (
    <ActionTiles>
      <ActionTiles.Tile
        key={allMarkets.key}
        active={
          selectedSubMarketGroupType ? selectedSubMarketGroupType === SubMarketGroupType.ALL : true
        }
        activeIcon={allMarkets.active}
        defaultIcon={allMarkets.default}
        onClick={() => handleTileClick(undefined)}
      >
        <Translation {...allMarkets.translation} />
      </ActionTiles.Tile>
      {groupedTemplates.map(({ type }) => {
        const icons = getSubMarketGroupIcons(eventTypeId)[type];
        const isActive = selectedSubMarketGroupType === type;

        return (
          <ActionTiles.Tile
            active={isActive}
            key={icons.key}
            activeIcon={icons.active}
            defaultIcon={icons.default}
            onClick={() => handleTileClick(type)}
          >
            <Translation {...icons.translation} />
          </ActionTiles.Tile>
        );
      })}
    </ActionTiles>
  );
};
